export const FETCHED_JABRATOKENS = 'FETCHED_JABRATOKENS';
export const SEARCHPAGE_HEIGHT_DETERMINDED = 'SEARCHPAGE_HEIGHT_DETERMINDED';
